module.exports = __webpack_public_path__ + "img/2-300x160.9c9ae95a.jpg";